// @ts-nocheck
import {
  BankOutlined,
  DeleteOutlined,
  FileTextOutlined,
  TeamOutlined,
  UploadOutlined,
  UserOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Popconfirm,
  Progress,
  Row,
  Select,
  Space,
  Tag,
  Tooltip,
  Typography,
  Upload,
  message,
} from 'antd'
import dayjs from 'dayjs'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { memo, useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { Document } from 'react-pdf'
import { blue, yellowPrimary } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import { AvatarHasName } from '../../../components/Common/Avatar'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import EmptyContent from '../../../components/EmptyContent'
import PageTitle from '../../../components/PageTitle'
import PopupRenameFile from '../../../components/PopupRenameFile'
import PopupSign from '../../../components/PopupSign/PopupSign'
import SelectGroupPopup from '../../../components/SelectGroupPopup/SelectGroupPopup'
import SelectPeoplePopup from '../../../components/SelectPeoplePopup/SelectPeoplePopup'
import { systemName, envName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  DATE_TIME_FORMAT_DEFAULT,
  DIGITAL_SIGN_PROVIDER,
  DIGITAL_TYPE_SIGN_SYSTEM,
  DOCUMENT_TYPE,
} from '../../../constants'
import { Container } from '../../../layouts/Container/Container'
import DashboardLayout from '../../../layouts/DashboardLayout'
import utils from '../../../utils'
import validator from '../../../validator'
import AuthoritiesActionModal from '../../AuthoritiesPage/AuthoritiesActionModal'
import {
  FormActionFooter,
  SelectList,
  SelectTitle,
  UploadFileListItem,
  UploadFileListWrapper,
} from './InternalDocumentIncomingDocCreatePageStyled'

const { RangePicker } = DatePicker
const { Option } = Select
const { TextArea } = Input
const { Title } = Typography

const InternalDocumentIncomingDocCreatePage = props => {
  const {
    history,
    internalDocumentStore,
    fileStore,
    bookStore,
    authorityStore,
    companyStore,
    loadingAnimationStore,
    signedDocumentStore,
    connectedDocumentStore,
    selectPeopleStore,
    ScanPdfStore,
    authenticationStore,
  } = props

  const { responseSign } = signedDocumentStore
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const { authorityIssuedsList } = authorityStore

  const { currentUser } = authenticationStore

  const { bookGroupList, bookListOfGroup } = bookStore
  // Dữ liệu văn bản nhận từ trục
  const { dataReceiveDocument } = connectedDocumentStore
  const [form] = Form.useForm()

  const [selectedBookGroupId, setSelectedBookGroupId] = useState(null)
  // For Rename file
  const [fileExt, setFileExt] = useState(undefined)
  const [fileTargetRename, setFileTargetRename] = useState(null)
  const [isRenameFileFromTruc, setIsRenameFileFromTruc] = useState(false)
  const [isModalVisibleRenameFile, setIsModalVisibleRenameFile] = useState(
    false
  )
  // List file nhận từ thiết bị
  const [fileList, setFileList] = useState([])
  // List file nhận từ trục
  const [fileFromTruc, setFileFromTruc] = useState([])
  // vẽ ngầm canvas ký số
  const [viewPortPdf, setViewPortPdf] = useState()
  const [fileRender, setFileRender] = useState()
  const [dataSignSavis, setDataSignSavis] = useState()
  // Ký số popup
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)
  const [handlerList, setHandlerList] = useState([])
  const [combinerList, setCombinerList] = useState([])
  const [followerList, setFollowerList] = useState([])

  const [isProcessing, setIsProcessing] = useState(false)
  const [progressPercent, setProgressPercent] = useState(0)
  const [hasProcessedFirstFile, setHasProcessedFirstFile] = useState(false)
  const [pdfScanData, setPdfScanData] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      // Validate prerequisites before processing
      if (!fileList || !Array.isArray(fileList) || fileList.length !== 1) {
        console.warn('Invalid fileList:', fileList)
        return
      }

      if (hasProcessedFirstFile) {
        console.log('File already processed, skipping...')
        return
      }

      const file = fileList[0]
      if (!file || !file.originFileObj || !file.name.endsWith('.pdf')) {
        console.error('Invalid file object:', file)
        // message.error('Chỉ hỗ trợ file PDF. Vui lòng chọn lại file.')
        return
      }

      setIsProcessing(true)
      setProgressPercent(0)

      const interval = setInterval(() => {
        setProgressPercent(prev => {
          if (prev >= 90) return prev
          return prev + 10
        })
      }, 500)

      try {
        // Validate ScanPdfStore exists and has required methods
        if (!ScanPdfStore || typeof ScanPdfStore.getOcrStatus !== 'function') {
          throw new Error('ScanPdfStore service không khả dụng')
        }

        const limitRequest = await ScanPdfStore.getOcrStatus()

        // Validate limit request response
        if (
          !limitRequest ||
          !limitRequest.data ||
          typeof limitRequest.data.thisMonthRequestCount === 'undefined'
        ) {
          console.warn('Invalid limit request response:', limitRequest)
          // Continue processing despite invalid response
        } else if (limitRequest.data.thisMonthRequestCount > 799) {
          clearInterval(interval)
          message.error('Đã vượt quá giới hạn 1000 request/tháng')
          setIsProcessing(false)
          setProgressPercent(0)
          return
        }

        // Validate recognizeText method exists
        if (typeof ScanPdfStore.recognizeText !== 'function') {
          throw new Error('Chức năng nhận dạng văn bản không khả dụng')
        }

        const response = await ScanPdfStore.recognizeText(file.originFileObj)

        // Comprehensive response validation
        if (!response) {
          throw new Error('Không nhận được phản hồi từ server')
        }

        if (!response.data) {
          throw new Error('Phản hồi từ server không chứa dữ liệu')
        }

        if (!response.data.data) {
          throw new Error('Dữ liệu nhận dạng trống')
        }

        // Validate the structure of the returned data
        const responseData = response.data.data
        if (!responseData.raw_data) {
          console.warn('Missing raw_data in response:', responseData)
          throw new Error('Dữ liệu thô không tồn tại')
        }

        setPdfScanData(responseData)
        setProgressPercent(100)
        setHasProcessedFirstFile(true)
      } catch (error) {
        console.error('Error in recognizeText:', error)
        setPdfScanData(null)
        setProgressPercent(0)
        setHasProcessedFirstFile(false)

        // More specific error messages
        const errorMessage =
          error.message || 'Có lỗi xảy ra khi xử lý file. Vui lòng thử lại.'
        message.error(errorMessage)
      } finally {
        clearInterval(interval)
        setIsProcessing(false)
      }
    }

    // Only run in production environment
    if (envName === 'prod' && currentUser?.username !== 'vanthuttatm') {
      fetchData()
    }
  }, [fileList, ScanPdfStore, hasProcessedFirstFile, envName])

  const parseDocumentData = useCallback(lines => {
    // Validate input data
    if (!lines) {
      console.warn('parseDocumentData: lines is null or undefined')
      return null
    }

    if (!Array.isArray(lines)) {
      console.warn('parseDocumentData: lines is not an array:', typeof lines)
      return null
    }

    if (lines.length === 0) {
      console.warn('parseDocumentData: lines array is empty')
      return null
    }

    // Validate each line object
    const validLines = lines.filter(lineObj => {
      if (!lineObj || typeof lineObj !== 'object') {
        console.warn('Invalid line object:', lineObj)
        return false
      }
      if (typeof lineObj.line !== 'string') {
        console.warn('Line object missing string property:', lineObj)
        return false
      }
      return true
    })

    if (validLines.length === 0) {
      console.warn('No valid lines found after filtering')
      return null
    }

    const document = {
      header: [],
      subject: '',
      date: '',
      body: [],
    }

    let currentSection = 'header'
    let subjectLines = []
    let subjectLineCount = 0
    const maxSubjectLines = 3
    let isQuyetDinhSection = false
    let isBodySection = false

    // Check if document contains "QUYẾT ĐỊNH"
    const isQuyetDinhDoc = validLines.some(lineObj => {
      try {
        return lineObj.line && lineObj.line.includes('QUYẾT ĐỊNH')
      } catch (e) {
        console.warn('Error checking line for QUYẾT ĐỊNH:', e)
        return false
      }
    })

    try {
      if (isQuyetDinhDoc) {
        // Logic for "QUYẾT ĐỊNH" document
        for (let i = 0; i < validLines.length; i++) {
          const lineObj = validLines[i]
          if (!lineObj || !lineObj.line) continue

          const line = lineObj.line.trim()
          if (!line) continue // Skip empty lines

          // Check for document number
          if (line.match(/^(?:Số|Só)[:\s]+[\d\/A-Z-]+/i)) {
            document.header.push(line)
            currentSection = 'subject'
            continue
          }

          // Check for date
          if (
            line.match(/ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i) ||
            line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
          ) {
            if (!document.date) document.date = line
            continue
          }

          // Start of QUYẾT ĐỊNH section
          if (line.includes('QUYẾT ĐỊNH')) {
            isQuyetDinhSection = true
            currentSection = 'subject'
            continue
          }

          // Start of body (when encountering "Điều 1" or "VIỆN TRƯỞNG")
          if (line.match(/^Điều\s+\d+\./) || line.includes('VIỆN TRƯỞNG')) {
            isBodySection = true
            currentSection = 'body'
          }

          // Assign lines to appropriate sections
          if (currentSection === 'header') {
            document.header.push(line)
          } else if (
            currentSection === 'subject' &&
            isQuyetDinhSection &&
            !isBodySection
          ) {
            subjectLines.push(line)
          } else if (currentSection === 'body') {
            document.body.push(line)
          }
        }

        // Join subject lines and clean up
        document.subject = subjectLines
          .filter(
            line =>
              line &&
              !line.match(/ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i)
          )
          .join(' ')
          .trim()
      } else {
        // Logic for non-"QUYẾT ĐỊNH" document (original code with validation)
        for (let i = 0; i < validLines.length; i++) {
          const lineObj = validLines[i]
          if (!lineObj || !lineObj.line) continue

          const line = lineObj.line
          if (!line) continue // Skip empty lines

          // Check for document number patterns
          if (
            line.startsWith('Số:') ||
            line.startsWith('Só:') ||
            line.match(/^(?:Số|Só)\s*:\s*\d+/) ||
            line.match(/^(?:Số|Só)\s+\d+/)
          ) {
            document.header.push(line)
            currentSection = 'subject'
            continue
          }

          if (currentSection === 'subject') {
            // Skip date pattern ONLY in subject section
            if (
              line.match(
                /ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i
              ) ||
              line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
            ) {
              if (!document.date) document.date = line
              continue
            }

            if (subjectLineCount < maxSubjectLines) {
              subjectLines.push(line)
              subjectLineCount++
            } else {
              currentSection = 'body'
              document.body.push(line)
            }
            continue
          }

          // For header and body sections, keep all lines including date patterns
          if (currentSection === 'header') {
            document.header.push(line)
            if (
              line.match(
                /ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i
              ) ||
              line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
            ) {
              if (!document.date) document.date = line
            }
          } else {
            document.body.push(line)
            if (
              line.match(
                /ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i
              ) ||
              line.match(/^(Hà Nội|TP\.|Thành phố).*ngày/i)
            ) {
              if (!document.date) document.date = line
            }
          }
        }

        // Clean up subject by removing any remaining date patterns
        document.subject = subjectLines
          .filter(
            line =>
              line &&
              !line.match(/ngày[\s\/]+\d{1,2}\s+tháng\s+\d{1,2}\s+năm\s+\d{4}/i)
          )
          .join(' ')
          .trim()
      }
    } catch (error) {
      console.error('Error in parseDocumentData:', error)
      return null
    }

    return document
  }, [])

  const safeJsonParse = useCallback(jsonString => {
    if (!jsonString || typeof jsonString !== 'string') {
      console.warn('Invalid JSON string provided:', typeof jsonString)
      return null
    }

    try {
      // First attempt: direct parsing
      return JSON.parse(jsonString)
    } catch (error) {
      console.warn('Direct JSON parse failed, attempting fixes:', error.message)

      try {
        // Second attempt: fix common escape character issues
        let fixedJson = jsonString
          // Fix invalid escape sequences
          .replace(/\\(?!["\\/bfnrt]|u[0-9a-fA-F]{4})/g, '\\\\')
          // Fix unescaped quotes in strings (basic fix)
          .replace(/([^\\])"([^"]*[^\\])"([^,}\]])/g, '$1\\"$2\\"$3')
          // Remove invalid control characters
          .replace(/[\x00-\x1F\x7F]/g, '')

        return JSON.parse(fixedJson)
      } catch (secondError) {
        console.warn('Fixed JSON parse also failed:', secondError.message)

        try {
          // Third attempt: extract JSON-like data using regex
          const jsonMatch = jsonString.match(/\[.*\]/s)
          if (jsonMatch) {
            const extractedJson = jsonMatch[0]
              .replace(/\\(?!["\\/bfnrt]|u[0-9a-fA-F]{4})/g, '\\\\')
              .replace(/[\x00-\x1F\x7F]/g, '')
            return JSON.parse(extractedJson)
          }
        } catch (thirdError) {
          console.error('All JSON parsing attempts failed:', thirdError.message)
        }

        return null
      }
    }
  }, [])

  const extractDataFromRawString = useCallback(
    rawString => {
      if (!rawString || typeof rawString !== 'string') {
        return null
      }

      const extractedData = {}

      try {
        // Extract document number using regex
        const soMatch = rawString.match(/(?:Số|So|S[óoốồổỗộ]):\s*([^\n\r]+)/i)
        if (soMatch) {
          const soValue = soMatch[1].trim()
          const numberMatch = soValue.match(/(\d+)\/(.+)/)
          if (numberMatch) {
            extractedData.incoming_number = numberMatch[1]
            extractedData.document_number = soValue.replace(
              /(N?V?)KHCNM/gi,
              'VKHCNM'
            )
          }
        }

        // Extract title/subject
        const vvMatch = rawString.match(/V\/v[:\s]+([^\n\r]+)/i)
        if (vvMatch) {
          extractedData.title = vvMatch[1].trim()
        }

        // Extract date
        const dateMatch = rawString.match(
          /ngày\s+(\d{1,2})\s+tháng\s+(\d{1,2})\s+năm\s+(\d{4})/i
        )
        if (dateMatch && moment) {
          try {
            const momentDate = moment(
              `${dateMatch[3]}-${dateMatch[2]}-${dateMatch[1]}`
            )
            if (momentDate.isValid()) {
              extractedData.date_issued = momentDate
            }
          } catch (momentError) {
            console.warn(
              'Error creating moment date in alternative extraction:',
              momentError
            )
          }
        }

        return extractedData
      } catch (error) {
        console.error('Error in extractDataFromRawString:', error)
        return null
      }
    },
    [moment]
  )

  let structuredData = null
  let rawDataParsingError = null

  try {
    if (pdfScanData && pdfScanData.raw_data) {
      console.log('Attempting to parse raw_data...')

      const parsedRawData = safeJsonParse(pdfScanData.raw_data)

      if (parsedRawData) {
        console.log('Successfully parsed raw_data, attempting to structure...')
        structuredData = parseDocumentData(parsedRawData)
        if (structuredData) {
          console.log('Successfully structured document data')
        } else {
          console.warn('Failed to structure document data')
        }
      } else {
        rawDataParsingError = 'Không thể phân tích dữ liệu JSON từ server'
        console.error('Failed to parse raw_data after all attempts')

        // Show user-friendly error message
        message.warning(
          'Dữ liệu nhận được có định dạng không hợp lệ. Vui lòng thử lại hoặc liên hệ hỗ trợ.'
        )
      }
    } else {
      console.warn('No pdfScanData or raw_data available')
    }
  } catch (error) {
    console.error('Error in structuredData processing:', error)
    rawDataParsingError = error.message
    structuredData = null

    // Show user-friendly error message
    message.error('Có lỗi xảy ra khi xử lý dữ liệu. Vui lòng thử lại.')
  }

  useEffect(() => {
    if (!structuredData) {
      console.log('No structured data available for form population')

      // If there was a parsing error but we still have some data, try alternative processing
      if (rawDataParsingError && pdfScanData && pdfScanData.raw_data) {
        console.log('Attempting alternative data extraction...')

        try {
          // Try to extract basic information from raw string without JSON parsing
          const rawString = String(pdfScanData.raw_data)
          const extractedData = extractDataFromRawString(rawString)

          if (extractedData && Object.keys(extractedData).length > 0) {
            console.log(
              'Successfully extracted data from raw string:',
              extractedData
            )
            form.setFieldsValue(extractedData)
            message.success('Đã trích xuất được một phần thông tin từ tài liệu')
          }
        } catch (alternativeError) {
          console.error('Alternative extraction also failed:', alternativeError)
        }
      }

      return
    }

    // Validate form exists
    if (!form || typeof form.setFieldsValue !== 'function') {
      console.error('Form object is not available or invalid')
      message.error('Lỗi hệ thống: Form không khả dụng')
      return
    }

    try {
      let rawData = null

      // Safely parse raw data using the safe parser
      if (pdfScanData && pdfScanData.raw_data) {
        rawData = safeJsonParse(pdfScanData.raw_data)
      }

      // ... rest of the existing form population logic remains the same
      // 1. Extract so_hieu và so_den with validation
      let soHieu = ''
      let soDen = ''
      const headerLines = Array.isArray(structuredData.header)
        ? structuredData.header
        : []

      const rawSoHieuLine = headerLines.find(
        line =>
          typeof line === 'string' &&
          (line.startsWith('Số') || line.startsWith('Só'))
      )

      if (rawSoHieuLine) {
        const cleanedLine = rawSoHieuLine.replace(/\s+/g, ' ').trim()
        let match = cleanedLine.match(/(?:Số|So|S[óoốồổỗộ]):\s*(\d+)\/(.+)/i)
        if (match) {
          soDen = match[1]
          soHieu = `${soDen}/${match[2].trim()}`
        } else {
          match = cleanedLine.match(
            /(?:Số|So|S[óoốồổỗộ]):\s*([\d\s]+)\s+([A-Z].+)/i
          )
          if (match) {
            soDen = match[1].replace(/\s+/g, '')
            soHieu = `${soDen}/${match[2].trim()}`
          } else {
            match = cleanedLine.match(/(?:Số|So|S[óoốồổỗộ])\s+(\d+)\s+\/(.+)/i)
            if (match) {
              soDen = match[1]
              soHieu = `${soDen}/${match[2].trim()}`
            } else {
              match = cleanedLine.match(
                /(?:Số|So|S[óoốồổỗộ]):\s*([\d\s]+)\/(.+)/i
              )
              if (match) {
                soDen = match[1].replace(/\s+/g, '')
                soHieu = `${soDen}/${match[2].trim()}`
              } else {
                match = cleanedLine.match(
                  /(?:Số|So|S[óoốồổỗộ])\s+(\d+)\s+([A-Z].+)/i
                )
                if (match) {
                  soDen = match[1]
                  soHieu = `${soDen}/${match[2].trim()}`
                } else {
                  match = cleanedLine.match(
                    /(?:Số|So|S[óoốồổỗộ])\s*:\s*(\d+)\s+([A-Z].+)/i
                  )
                  if (match) {
                    soDen = match[1]
                    soHieu = `${soDen}/${match[2].trim()}`
                  }
                }
              }
            }
          }
        }

        if (!match) {
          const fallbackMatch = cleanedLine.match(
            /(?:Số|So|S[óoốồổỗộ]):\s*(.+)/i
          )
          if (fallbackMatch) {
            const parts = fallbackMatch[1].trim().split(/\s+/)
            if (parts.length >= 2) {
              let numberPart = ''
              let textPart = ''
              let foundText = false
              for (let i = 0; i < parts.length; i++) {
                if (/^\d+$/.test(parts[i]) && !foundText) {
                  numberPart += parts[i]
                } else {
                  foundText = true
                  textPart += (textPart ? ' ' : '') + parts[i]
                }
              }
              if (numberPart && textPart) {
                soDen = numberPart
                soHieu = `${soDen}/${textPart}`
              }
            }
          }
        }
      }

      // Fallback to raw_data if needed
      if (
        (!soHieu || !soDen) &&
        typeof rawData === 'string' &&
        rawData.includes('\n')
      ) {
        const lines = rawData.split('\n')
        for (let line of lines) {
          if (!line || typeof line !== 'string') continue

          const cleanedLine = line.trim()
          if (cleanedLine.startsWith('Số') || cleanedLine.startsWith('Só')) {
            let match = cleanedLine.match(
              /(?:Số|So|S[óoốồổỗộ]):\s*(\d+)\/(.+)/i
            )
            if (match) {
              soDen = match[1]
              soHieu = `${soDen}/${match[2].trim()}`
              break
            } else {
              match = cleanedLine.match(
                /(?:Số|So|S[óoốồổỗộ])\s+(\d+)\s+([A-Z].+)/i
              )
              if (match) {
                soDen = match[1]
                soHieu = `${soDen}/${match[2].trim()}`
                break
              }
            }
          }
        }
      }

      // 2. Extract trich_yeu with validation
      let trichYeu =
        typeof structuredData.subject === 'string' ? structuredData.subject : ''

      // Fallback to raw_data
      if (!trichYeu && typeof rawData === 'string' && rawData.includes('\n')) {
        const lines = rawData.split('\n')
        for (let line of lines) {
          if (
            line &&
            typeof line === 'string' &&
            line.trim().startsWith('V/v')
          ) {
            trichYeu = line.substring(4).trim()
            break
          }
        }
      }

      // 3. Extract ngay_ban_hanh with validation
      const dateRaw =
        typeof structuredData.date === 'string' ? structuredData.date : ''
      const dateMatch = dateRaw?.match(
        /ngày\s+(\d{1,2})\s+tháng\s+(\d{1,2})\s+năm\s+(\d{4})/i
      )

      let momentDate = null
      if (dateMatch && moment) {
        try {
          momentDate = moment(`${dateMatch[3]}-${dateMatch[2]}-${dateMatch[1]}`)
          if (!momentDate.isValid()) {
            console.warn('Invalid moment date created:', momentDate)
            momentDate = null
          }
        } catch (momentError) {
          console.error('Error creating moment date:', momentError)
          momentDate = null
        }
      }

      // Fallback to raw_data for date
      if (!momentDate && rawData && moment) {
        const rawDataString = rawData.toString()
        const dateMatchRaw = rawDataString?.match(
          /ngày\s+(\d{1,2})\s+tháng\s+(\d{1,2})\s+năm\s+(\d{4})/i
        )
        if (dateMatchRaw) {
          try {
            momentDate = moment(
              `${dateMatchRaw[3]}-${dateMatchRaw[2]}-${dateMatchRaw[1]}`
            )
            if (!momentDate.isValid()) {
              momentDate = null
            }
          } catch (momentError) {
            console.error('Error creating fallback moment date:', momentError)
          }
        }
      }

      // Clean up soHieu
      if (soHieu && typeof soHieu === 'string') {
        soHieu = soHieu.replace(/(N?V?)KHCNM/gi, 'VKHCNM')
      }

      // Populate form with validated data
      const formData = {}

      if (soHieu) formData.document_number = soHieu
      if (soDen) formData.incoming_number = soDen
      if (trichYeu) formData.title = trichYeu
      if (momentDate) formData.date_issued = momentDate

      console.log('Populating form with data:', formData)

      // Only set fields if we have at least some data
      if (Object.keys(formData).length > 0) {
        form.setFieldsValue(formData)
        // message.success('Đã điền thông tin tự động từ tài liệu')
      } else {
        message.warning(
          'Không thể trích xuất thông tin từ tài liệu. Vui lòng nhập thủ công.'
        )
      }
    } catch (error) {
      console.error('Error in form population useEffect:', error)
      message.error(
        'Có lỗi khi điền thông tin vào form. Vui lòng nhập thủ công.'
      )
    }
  }, [pdfScanData, structuredData, form, rawDataParsingError])

  const [
    isVisibleAuthoritiesActionModal,
    setIsVisbleAuthoritiesActionModal,
  ] = useState(false)

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setCombinerList([
      ...selectUserData[ASSIGNEE_TYPE.COMBINER],
      ...selectDepartmentData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const handleSelectBookGroupId = bookGroupId => {
    if (!bookGroupId) setSelectedBookGroupId(null)
    form.setFieldsValue({
      book_id: undefined,
    })
    form.validateFields(['book_id'])
    setSelectedBookGroupId(bookGroupId)
    loadingAnimationStore.showSpinner(true)
    bookStore
      .getBookByBookGroupId(bookGroupId)
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  const handleSelectBookId = async bookId => {
    if (!bookId) return
    try {
      const response = await internalDocumentStore.suggestIncomingNumber(bookId)
      form.setFieldsValue({
        incoming_number: response.data?.incoming_number,
      })
      form
        .validateFields(['incoming_number'])
        .catch(err => message.error(err?.vi || 'Đã có lỗi xảy ra!'))
    } catch (error) {
      // console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra!')
    }
  }

  useEffect(() => {
    form.validateFields(['incoming_number'])
  }, [form])

  const handleChangeFile = info => {
    if (info.fileList.length === 0) {
      form.setFieldsValue({ file_upload: undefined })
      setFileList([])
      setHasProcessedFirstFile(false)
      return
    }
    const filteredFileList = info.fileList.filter(
      (elem, index, fileList) =>
        fileList.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }

  const handleRemoveFileFromUploadList = useCallback(
    fileUID => {
      const newFileList = fileList.filter(file => file.uid !== fileUID)
      setFileList(newFileList)
      if (newFileList.length === 0) {
        form.setFieldsValue({
          attachments: [],
        })
        setHasProcessedFirstFile(false)
        setPdfScanData(null)
      }
    },
    [fileList]
  )

  const handleRemoveFileFromTruc = file_id => {
    setFileFromTruc(
      toJS([...fileFromTruc]).filter(file => file.fileId !== file_id)
    )
  }

  // vẽ ngầm canvas lấy kích thước file pdf (Start ký savis)
  const renderPage = async pdf => {
    const page = await pdf.getPage(1)
    const viewport = page.getViewport({ scale: 1 })
    setViewPortPdf({ height: viewport.height, width: viewport.width })
  }

  const renderDocument = () => {
    return (
      <Document
        noData={null}
        style={{ display: 'none' }}
        file={fileRender?.originFileObj}
        onLoadSuccess={pdf => onDocumentLoadSuccess(pdf)}
      />
    )
  }

  const onDocumentLoadSuccess = pdf => {
    renderPage(pdf, 1)
  }

  const handleBeforeSign = (file, index) => {
    setFileRender(file)
    setDataSignSavis({
      file: file,
      index: index,
    })
  }

  useEffect(() => {
    if (!responseSign) return
    const { fileSignId, fileSignName } = responseSign.data.listSignFile[0]
    const newFileList = [...fileList]
    newFileList[dataSignSavis.index] = {
      name: fileSignName,
      id: fileSignId,
      uid: dataSignSavis.file.uid,
      isSigned: true,
      type: 'application/pdf',
    }
    setFileList(newFileList)
  }, [responseSign])

  const handleSignSavis = (file, index) => {
    loadingAnimationStore.showSpinner(true)
    const formData = new FormData()
    formData.append('file', file.originFileObj)
    fileStore
      .uploadFile(formData)
      .then(res => {
        const dataSubmit = {
          image: '',
          reason: 'Signed',
          location: 'VietNam',
          provider: DIGITAL_SIGN_PROVIDER,
          contactInfo: '',
          type: DIGITAL_TYPE_SIGN_SYSTEM,
          visibleType: 8,
          isVisible: 1,
          page: 1,
          llx: 100,
          lly: 780,
          urx: 590,
          ury: 820,
          listSignFile: [
            {
              fileId: res.data.file_id,
            },
          ],
        }
        signedDocumentStore
          .signDocumentSavis(dataSubmit)
          .then(res => {
            const {
              fileSignId,
              fileOriginName,
              fileSignName,
            } = res.data.listSignFile[0]
            const newFileList = [...fileList]
            newFileList[index] = {
              name: fileSignName,
              id: fileSignId,
              uid: file.uid,
              isSigned: true,
              type: 'application/pdf',
            }
            setFileList(newFileList)
            loadingAnimationStore.showSpinner(false)
            message.success(`Văn bản "${fileOriginName}" đã được kí`).then()
          })
          .catch(err => {
            loadingAnimationStore.showSpinner(false)
            return message.error(err?.vi || 'Ký số thất bại!')
          })
      })
      .catch(() => loadingAnimationStore.showSpinner(false))
  }
  // End ký savis

  const handleCreateInternalDocumentIncoming = async submitData => {
    await internalDocumentStore.createInternalDocumentIncoming(submitData)
    message.success(`Tạo văn bản thành công`)
  }
  const [start_date, setStartDate] = useState(null)
  const [end_date, setEndDate] = useState(null)

  const handleDateChange = async value => {
    setStartDate(value ? moment(value[0]) : null)
    setEndDate(value ? moment(value[1]) : null)
  }

  const onFinish = async values => {
    const fileSignedList = fileList
      .filter(file => file.isSigned)
      .map(file => file.id)
    const {
      authority_issued_id,
      book_id,
      date_issued,
      document_number,
      outgoing_date,
      signer,
      title,
      book_group_id,
      urgency_level,
      incoming_number,
    } = values
    loadingAnimationStore.showSpinner(true)
    const assigneesList = [
      ...followerList,
      ...handlerList,
      ...combinerList,
    ].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    let fileBoldFormTrucList = []
    await Promise.all(
      fileFromTruc.map(file => fileStore.downloadAttachmentTruc(file.fileId))
    )
      .then(response => {
        fileBoldFormTrucList = response
      })
      .catch(err => {
        console.log(err)
        message.warning(
          'Download file từ trục liên thông có lỗi, bạn hãy thử nhận lại văn bản!'
        )
      })
    const uploadedFileFromTruc = await Promise.all(
      fileBoldFormTrucList.map((fileBold, index) => {
        const formData = new FormData()
        formData.append('file', fileBold.data, fileFromTruc[index].name)
        return fileStore.uploadFile(formData)
      })
    )
    const idFileUploadFromTruc = uploadedFileFromTruc.map(
      file => file.data.file_id
    )
    const batchUploadList = []
    fileList.forEach(file => {
      if (file.isSigned) return
      const formData = new FormData()
      formData.append('file', file.originFileObj, file.name)
      batchUploadList.push(fileStore.uploadFile(formData))
    })

    try {
      let response = await Promise.all(batchUploadList)
      const submitValues = {
        authority_issued_id: authority_issued_id,
        assign_user: {
          assignees: assigneesList,
          start_date: start_date,
          end_date: end_date,
        },
        attachments: response
          .map(response => response.data.file_id)
          .concat(fileSignedList)
          .concat(idFileUploadFromTruc),
        book_group_id: book_group_id,
        book_id: book_id,
        date_issued: date_issued ? moment(date_issued).toISOString() : null,
        document_number: document_number?.toUpperCase(),
        document_type: null,
        incoming_number: incoming_number,
        outgoing_date: outgoing_date
          ? moment(outgoing_date).toISOString()
          : null,
        sign_date: null,
        signer: signer,
        title: title,
        urgency_level: urgency_level,
      }
      await handleCreateInternalDocumentIncoming(submitValues)
      handleCancelCreate()
    } catch (error) {
      console.log(error)
      message.error(error.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const handleCancelCreate = () => {
    form.resetFields()
    history.push('/internal-document/incoming-document')
  }

  // For đổi tên file nhận từ thiết bị
  const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
      type: originalFile.type,
      lastModified: originalFile.lastModified,
    })
  }

  const submitRenameFile = async value => {
    const index = fileTargetRename?.index
    // đổi tên file nhận từ trục
    if (isRenameFileFromTruc) {
      const fileFromTrucAfterRename = [...fileFromTruc]
      fileFromTrucAfterRename[index] = {
        fileId: fileTargetRename.fileId,
        name: value.rename + fileExt,
      }
      setFileFromTruc(fileFromTrucAfterRename)
      setIsModalVisibleRenameFile(false)
      message.success('Đổi tên file thành công')
      return
    }
    // đổi tên file nhận từ thiết bị (file chưa ký)
    if (fileTargetRename.originFileObj) {
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      newFileList[index].originFileObj = renameFile(
        newFileList[index].originFileObj,
        newFileList[index].name
      )
      setFileList(newFileList)
      setIsModalVisibleRenameFile(false)
      message.success('Đổi tên file thành công')
    }
    // đổi tên file nhận từ thiết bị (file đã ký)
    if (!fileTargetRename.originFileObj) {
      await fileStore.handleRenameFile(
        fileTargetRename.id,
        value.rename + fileExt
      )
      setIsModalVisibleRenameFile(false)
      const newFileList = [...fileList]
      newFileList[index].name = value.rename + fileExt
      setFileList(newFileList)
      message.success('Đổi tên file thành công')
    }
  }
  useEffect(() => {
    selectPeopleStore.clearSelected()
  }, [])
  useEffect(() => {
    if (
      !dataReceiveDocument ||
      !dataReceiveDocument.attachments ||
      !dataReceiveDocument.attachments.length
    )
      return
    setFileFromTruc([...toJS(dataReceiveDocument.attachments)])
  }, [])

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      try {
        authorityStore.setAuthorityIssuedsQueryParams({
          type: DOCUMENT_TYPE.INCOMING,
          key: null,
        })
        await authorityStore.getAuthorityIssueds()
        await companyStore.getCompanyList()
        const responseGetBookGroup = await bookStore.getBookGroup('DEN')
        const responseBookByBookGroupId = await bookStore.getBookByBookGroupId(
          responseGetBookGroup.data[0].id
        )
        const responseSuggestIncomingNumber = await internalDocumentStore.suggestIncomingNumber(
          responseBookByBookGroupId.data[0]?.id
        )
        form.setFieldsValue({
          book_group_id:
            responseGetBookGroup.data?.length > 0
              ? responseGetBookGroup.data[0].id
              : null,
          book_id:
            responseBookByBookGroupId.data?.length > 0
              ? responseBookByBookGroupId.data[0]?.id
              : null,
          incoming_number: responseSuggestIncomingNumber.data?.incoming_number,
        })
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      form.resetFields()
      bookStore.clearStore()
      signedDocumentStore.clearFilePDFSign()
      selectPeopleStore.clearSelectPeopleStore()
    }
  }, [])

  // sign popup
  const handleClosePopupSign = () => {
    setIsVisiblePopupSign(false)
    signedDocumentStore.clearFilePDFSign()
  }

  const handleOpenPopupSign = (file, index) => {
    setDataSignSavis({
      file: file.originFileObj,
      index: index,
    })
    const fileBlob = new Blob([file.originFileObj], { type: 'application/pdf' })
    signedDocumentStore.setFileBlob(fileBlob)
    signedDocumentStore.setOriginFileObj(file.originFileObj)
    setIsVisiblePopupSign(true)
  }

  const [fieldsRenameFile, setFieldsRenameFile] = useState([
    {
      name: ['rename'],
      value: '',
    },
  ])

  const handleOpenPopupRenameFile = (file, index) => {
    setFieldsRenameFile([
      {
        name: ['rename'],
        value: utils.removeExtensionFile(file.name),
      },
    ])
    setFileExt('.' + utils.getExtensionFile(file.name))
    setFileTargetRename({
      ...file,
      index: index,
    })
    setIsModalVisibleRenameFile(true)
  }
  const [
    keywordFilterDocumentNumber,
    setKeywordFilterDocumentNumber,
  ] = useState(null)

  const onChangeFilterDocumentNumber = keyword => {
    setKeywordFilterDocumentNumber(keyword === '' ? null : keyword)
  }

  const validateDocumentNumber = async (rule, value) => {
    if (!value || value.trim() === '') {
      return Promise.reject('Cần nhập ký tự, vui lòng không bỏ trống')
    } else if (value < 0) {
      return Promise.reject('Cần nhập số lớn hơn 0!')
    } else {
      if (value === undefined) return
      try {
        let bookId = form.getFieldValue('book_id')
        if (!bookId) {
          return Promise.reject('Chưa chọn sổ văn bản!')
        }
        const response = await internalDocumentStore.getWarningDocumentNumber(
          null,
          bookId,
          value,
          'INCOMING'
        )
        if (response.data.status === 'WARNING') {
          return Promise.reject(response.data.message)
        } else {
          return Promise.resolve()
        }
      } catch (error) {
        console.log(error)
        message.error(error?.vi || 'Đã có lỗi xảy ra!')
      }
    }
  }

  const validateIncomingNumber = async (rule, value) => {
    if (typeof value === 'string') {
      value = value.trim()
    }

    if (!value) {
      return Promise.reject('Vui lòng nhập số đến.')
    }

    if (isNaN(value)) {
      return Promise.reject('Số đến phải là số.')
    }
    try {
      let bookId = form.getFieldValue('book_id')
      if (!bookId) {
        return Promise.reject('Chưa chọn sổ văn bản!')
      }
      const response = await internalDocumentStore.suggestIncomingNumberv2(
        null,
        bookId,
        value,
        'INCOMING'
      )
      if (response.data.exists === true) {
        return Promise.reject(
          'Số đến văn bản đã sử dụng, vui lòng chọn số khác!'
        )
      } else {
        return Promise.resolve()
      }
    } catch (error) {
      // console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra!')
    }

    return Promise.resolve()
  }

  const filterSelectOption = (input, option) => {
    return (
      utils
        .nonAccentVietnamese(option.name)
        .indexOf(utils.nonAccentVietnamese(input)) >= 0
    )
  }

  const handleToggleAuthoritiesActionModal = bool => event => {
    setIsVisbleAuthoritiesActionModal(bool)
  }

  return (
    <>
      <DashboardLayout>
        <Helmet>
          <title>
            Tạo văn bản đến | {systemName} Quản lý VB {systemName}
          </title>
        </Helmet>
        <PageTitle location={props.location} title={'Tạo văn bản đến'} />
        <ContentBlockWrapper>
          <Container maxWidth={1000}>
            <Form
              form={form}
              scrollToFirstError={true}
              name={'create-incoming-document'}
              layout={'vertical'}
              style={{ paddingTop: '2rem' }}
              onFinish={onFinish}
              initialValues={{
                outgoing_date: moment(),
                signer: dataReceiveDocument && dataReceiveDocument.signer,
                title: dataReceiveDocument && dataReceiveDocument.subject,
                document_number:
                  dataReceiveDocument && dataReceiveDocument.code,
                authority_issued_id: authorityIssuedsList.find(
                  ({ name }) =>
                    name?.trim()?.toUpperCase() ===
                    dataReceiveDocument?.userFrom?.trim()?.toUpperCase()
                )?.id,
                date_issued:
                  dataReceiveDocument &&
                  dataReceiveDocument.promulgationDate &&
                  moment(dataReceiveDocument.promulgationDate),
              }}>
              <Row type={'flex'} gutter={30}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={'Nhóm sổ văn bản'}
                    name={'book_group_id'}
                    rules={[
                      {
                        required: true,
                        message: ' Vui lòng chọn nhóm sổ văn bản!',
                      },
                    ]}>
                    <Select
                      onChange={handleSelectBookGroupId}
                      showSearch
                      notFoundContent={<EmptyContent />}
                      filterOption={true}
                      optionFilterProp={'name'}
                      placeholder={'-- Chọn nhóm sổ văn bản --'}>
                      {bookGroupList.map(book => (
                        <Option key={book.id} value={book.id} name={book.name}>
                          {book.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={'Sổ văn bản'}
                    name={'book_id'}
                    rules={[
                      { required: true, message: ' Vui lòng chọn sổ văn bản!' },
                    ]}>
                    <Select
                      showSearch
                      onChange={handleSelectBookId}
                      notFoundContent={<EmptyContent />}
                      filterOption={true}
                      optionFilterProp={'name'}
                      placeholder={'-- Chọn sổ văn bản --'}>
                      {bookListOfGroup.map(book => (
                        <Option key={book.id} value={book.id} name={book.name}>
                          {book.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row type={'flex'} gutter={30}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={'Số hiệu'}
                    name={'document_number'}
                    rules={[
                      { required: true, message: ' ' },
                      { validator: validateDocumentNumber },
                    ]}>
                    <Input
                      // value={keywordFilterDocumentNumber}
                      // onChange={e =>
                      //   onChangeFilterDocumentNumber(e.target.value)
                      // }
                      style={{ textTransform: 'uppercase' }}
                      maxLength={50}
                      placeholder={'Nhập số hiệu văn bản'}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label={'Số đến'}
                    name={'incoming_number'}
                    rules={[
                      { required: true, message: '' },
                      { validator: validateIncomingNumber },
                    ]}>
                    <Input maxLength={50} placeholder={'Nhập số đến văn bản'} />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item
                label={'Trích yếu'}
                name={'title'}
                rules={[
                  {
                    required: true,
                    message: ' Vui lòng nhập trích yếu văn bản!',
                  },
                  { validator: validator.validateInputString },
                ]}>
                <TextArea
                  autoSize={{ minRows: 4 }}
                  placeholder={'Nhập trích yếu văn bản'}
                />
              </Form.Item>
              <Row type={'flex'} gutter={30}>
                <Col xs={24} md={12}>
                  <Form.Item
                    rules={[
                      { required: true, message: 'Vui lòng chọn ngày đến!' },
                    ]}
                    label={'Ngày đến'}
                    name={'outgoing_date'}>
                    <DatePicker
                      style={{ width: '100%' }}
                      format={DATE_TIME_FORMAT_DEFAULT}
                      showTime={{ defaultValue: dayjs('00:00', 'HH:mm') }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label={'Ngày ban hành'} name={'date_issued'}>
                    <DatePicker
                      style={{ width: '100%' }}
                      format={DATE_TIME_FORMAT_DEFAULT}
                      showTime={{ defaultValue: dayjs('00:00', 'HH:mm') }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row type={'flex'} gutter={30}>
                <Col xs={24} md={12}>
                  <Form.Item label={'Người ký'} name={'signer'}>
                    <Input maxLength={500} placeholder={'Nhập tên người ký'} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label={'Độ khẩn'} name={'urgency_level'}>
                    <Select
                      allowClear
                      notFoundContent={<EmptyContent />}
                      placeholder={'-- Chọn độ khẩn --'}>
                      <Option value={'001'}>Khẩn</Option>
                      <Option value={'002'}>Hỏa tốc</Option>
                      <Option value={'003'}>Hỏa tốc hẹn giờ</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                name={'attachments'}
                label={
                  fileFromTruc.length !== 0 ? (
                    <>
                      <span
                        style={{
                          color: '#ff4d4f',
                          fontFamily: 'SimSun, sans-serif',
                          marginRight: '2px',
                        }}>
                        *{' '}
                      </span>
                      Tài liệu đính kèm
                    </>
                  ) : (
                    'Tài liệu đính kèm'
                  )
                }
                rules={
                  fileFromTruc.length !== 0
                    ? null
                    : [
                        {
                          required: true,
                          message: ' Vui lòng chọn tài liệu đính kèm!',
                        },
                      ]
                }>
                <Upload
                  valuePropName={'fileList'}
                  fileList={fileList}
                  multiple={true}
                  beforeUpload={() => false}
                  onChange={handleChangeFile}
                  showUploadList={false}>
                  <Button icon={<UploadOutlined />}>
                    Chọn tài liệu đính kèm
                  </Button>
                </Upload>
              </Form.Item>
              {isProcessing && (
                <div style={{ margin: '0 70px 0 0' }}>
                  <Progress
                    percent={progressPercent}
                    status={progressPercent === 100 ? 'success' : 'active'}
                    showInfo={true}
                    strokeColor={{
                      '0%': '#108ee9',
                      '100%': '#87d068',
                    }}
                    format={percent => `  Đang xử lý ${percent}%`}
                  />
                </div>
              )}
              <UploadFileListWrapper>
                {fileList.map((file, index) => (
                  <UploadFileListItem
                    key={file.uid || file.id}
                    isSigned={file.isSigned}
                    isNotPDF={file.type !== 'application/pdf'}>
                    <FileTextOutlined />
                    <span>{file.name}</span>
                    {file.isSigned ? (
                      <Button
                        className={'digital-signature'}
                        type="text"
                        onClick={() => message.info('Đã ký!')}>
                        Đã ký
                      </Button>
                    ) : file.type !== 'application/pdf' ? (
                      <AccessControlAction
                        aclActionType={ACL_ACTION_TYPE.ky_so__INCOMING}>
                        <Button
                          className={'digital-signature'}
                          type="text"
                          onClick={() =>
                            message.info(
                              'Chỉ ký được file PDF, vui lòng chọn file khác!'
                            )
                          }>
                          Ký số
                        </Button>
                      </AccessControlAction>
                    ) : (
                      <AccessControlAction
                        aclActionType={ACL_ACTION_TYPE.ky_so__INCOMING}>
                        <Popconfirm
                          placement="top"
                          title={'Hãy chọn loại ký'}
                          onConfirm={() => handleOpenPopupSign(file, index)}
                          okText="Ký tùy chọn"
                          cancelText="Ký mặc đinh"
                          onCancel={() => handleSignSavis(file, index)}>
                          <Button
                            className={'digital-signature'}
                            type="text"
                            onClick={() => handleBeforeSign(file, index)}>
                            Ký số
                          </Button>
                        </Popconfirm>
                      </AccessControlAction>
                    )}
                    {
                      <Button
                        className={'rename'}
                        type="text"
                        onClick={() => {
                          setIsRenameFileFromTruc(false)
                          handleOpenPopupRenameFile(file, index)
                        }}>
                        Đổi tên
                      </Button>
                    }
                    <Tooltip title={'Xoá tập tin'}>
                      <DeleteOutlined
                        onClick={() =>
                          handleRemoveFileFromUploadList(file.uid, index)
                        }
                      />
                    </Tooltip>
                  </UploadFileListItem>
                ))}
                {fileFromTruc.map((file, index) => (
                  <UploadFileListItem key={file.fileId}>
                    <FileTextOutlined style={{ color: '1890FF' }} />
                    <span style={{ color: '#1890FF' }}>{file.name}</span>
                    <Button
                      className={'rename'}
                      type="text"
                      onClick={() => {
                        setIsRenameFileFromTruc(true)
                        handleOpenPopupRenameFile(file, index)
                      }}>
                      Đổi tên
                    </Button>
                    <Tooltip title={'Xoá tập tin'}>
                      <DeleteOutlined
                        onClick={() =>
                          handleRemoveFileFromTruc(file.fileId, index)
                        }
                      />
                    </Tooltip>
                  </UploadFileListItem>
                ))}
              </UploadFileListWrapper>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  gap: '30px',
                }}>
                <Form.Item
                  style={{ width: '100%' }}
                  label={'Cơ quan ban hành'}
                  rules={[
                    {
                      required: true,
                      message: 'Vui lòng chọn cơ quan ban hành!',
                    },
                  ]}
                  name={'authority_issued_id'}>
                  <Select
                    allowClear
                    showSearch
                    showArrow
                    filterOption={filterSelectOption}
                    notFoundContent={<EmptyContent />}
                    placeholder={'-- Chọn cơ quan ban hành --'}>
                    {authorityIssuedsList.map(authorityIssued => (
                      <Option
                        name={authorityIssued.name}
                        value={authorityIssued.id}
                        key={authorityIssued.id}>
                        {authorityIssued.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Button
                  style={{ marginBottom: '10px' }}
                  onClick={handleToggleAuthoritiesActionModal(true)}>
                  Tạo mới
                </Button>
              </div>

              <Title level={5} style={{ margin: '10px 0 15px 0' }}>
                Thông tin phân phát
              </Title>
              <div
                style={{
                  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
                  padding: '10px',
                }}>
                <Row type={'flex'} gutter={30}>
                  <Col md={24} lg={8}>
                    <SelectTitle>
                      <span>
                        <span style={{ marginRight: '10px' }}>
                          Lãnh đạo xử lý:
                        </span>
                      </span>
                      <Space>
                        <Tooltip title="Chọn người dùng" color={blue}>
                          <Button
                            icon={<UserOutlined style={{ color: blue }} />}
                            onClick={() => {
                              handleOpenSelectUserDepartmentPopup(
                                ASSIGNEE_TYPE.HANDLER
                              )
                            }}
                          />
                        </Tooltip>
                      </Space>
                    </SelectTitle>
                    <SelectList>
                      {/*Render lãnh đạo xử lý*/}
                      {handlerList.map(el => (
                        <Tag
                          className={'tag-selected'}
                          color={'blue'}
                          key={el.id}
                          closable
                          onClose={() =>
                            selectPeopleStore.handleRemoveSelect(el)
                          }>
                          <AvatarHasName
                            imgId={el.image_id}
                            size={22}
                            name={el.full_name}
                            icon={
                              (el.assignee_type ===
                                ASSIGNEE_TYPE.DEPARTMENT && <BankOutlined />) ||
                              (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                                <TeamOutlined />
                              ))
                            }
                          />
                        </Tag>
                      ))}
                    </SelectList>
                  </Col>

                  <Col md={24} lg={8}>
                    <SelectTitle>
                      <span>
                        <span style={{ marginRight: '10px' }}>
                          Người xử lý:
                        </span>
                      </span>
                      <Space>
                        <Tooltip title="Chọn người dùng" color={blue}>
                          <Button
                            icon={<UserOutlined style={{ color: blue }} />}
                            onClick={() => {
                              handleOpenSelectUserDepartmentPopup(
                                ASSIGNEE_TYPE.COMBINER
                              )
                            }}
                          />
                        </Tooltip>
                        <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                          <Button
                            icon={<TeamOutlined />}
                            style={{ color: yellowPrimary }}
                            onClick={() =>
                              handleOpenSelectGroupPopup(ASSIGNEE_TYPE.COMBINER)
                            }
                          />
                        </Tooltip>
                      </Space>
                    </SelectTitle>
                    <SelectList>
                      {/*Render danh sách người xử lý*/}
                      {combinerList.map(el => (
                        <Tag
                          className={'tag-selected'}
                          color={'blue'}
                          key={el.id}
                          closable
                          onClose={() =>
                            selectPeopleStore.handleRemoveSelect(el)
                          }>
                          <AvatarHasName
                            imgId={el.image_id}
                            size={22}
                            name={el.full_name}
                            icon={
                              (el.assignee_type ===
                                ASSIGNEE_TYPE.DEPARTMENT && <BankOutlined />) ||
                              (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                                <TeamOutlined />
                              ))
                            }
                          />
                        </Tag>
                      ))}
                    </SelectList>
                  </Col>
                  <Col md={24} lg={8}>
                    <SelectTitle>
                      <span>
                        <span style={{ marginRight: '10px' }}>
                          Phối hợp/ Theo dõi:
                        </span>
                      </span>
                      <Space>
                        <Tooltip title="Chọn người dùng" color={blue}>
                          <Button
                            icon={<UserOutlined style={{ color: blue }} />}
                            onClick={() => {
                              handleOpenSelectUserDepartmentPopup(
                                ASSIGNEE_TYPE.FOLLOWER
                              )
                            }}
                          />
                        </Tooltip>
                        <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                          <Button
                            icon={<TeamOutlined />}
                            style={{ color: yellowPrimary }}
                            onClick={() =>
                              handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                            }
                          />
                        </Tooltip>
                      </Space>
                    </SelectTitle>
                    <SelectList>
                      {/*Render danh sách người phối hợp và theo dõi*/}
                      {followerList.map(el => (
                        <Tag
                          className={'tag-selected'}
                          color={'blue'}
                          key={el.id}
                          closable
                          onClose={() =>
                            selectPeopleStore.handleRemoveSelect(el)
                          }>
                          <AvatarHasName
                            imgId={el.image_id}
                            size={22}
                            name={el.full_name}
                            icon={
                              (el.assignee_type ===
                                ASSIGNEE_TYPE.DEPARTMENT && <BankOutlined />) ||
                              (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                                <TeamOutlined />
                              ))
                            }
                          />
                        </Tag>
                      ))}
                    </SelectList>
                  </Col>
                </Row>
                <Row type={'flex'} gutter={30}>
                  <Col md={24} lg={8}>
                    <Form.Item
                      label={'Thời gian phân phát'}
                      name={'date_distribution'}>
                      <RangePicker
                        placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                        format={DATE_FORMAT_LIST}
                        style={{ width: '100%' }}
                        onChange={handleDateChange}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>
              <FormActionFooter>
                <Button onClick={handleCancelCreate}>Huỷ bỏ</Button>
                <Button
                  style={{ marginLeft: 10 }}
                  type={'primary'}
                  htmlType={'submit'}>
                  Tạo văn bản
                </Button>
              </FormActionFooter>
            </Form>
          </Container>
        </ContentBlockWrapper>
        <SelectPeoplePopup
          onlyOneUser={
            selectPeopleStore.assigneePopupType === ASSIGNEE_TYPE.HANDLER
          }
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
        />
        <SelectGroupPopup
          isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
          handleCancelSelectGroup={handleCancelSelectGroup}
          handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
        />
        {renderDocument()}
        <PopupSign
          isVisiblePopupSign={isVisiblePopupSign}
          handleClosePopupSign={handleClosePopupSign}
          hiddenSelectDocument
        />
        <PopupRenameFile
          isModalVisibleRenameFile={isModalVisibleRenameFile}
          handleCloseModalRenameFile={() => setIsModalVisibleRenameFile(false)}
          submitRenameFile={submitRenameFile}
          fieldsRenameFile={fieldsRenameFile}
          fileExt={fileExt}
        />
      </DashboardLayout>

      {isVisibleAuthoritiesActionModal && (
        <AuthoritiesActionModal
          disabledAuthoritiesTypePicker
          tabActive={DOCUMENT_TYPE.INCOMING}
          payloadModal={{
            status: true,
            isCreate: true,
            updatePayLoad: null,
          }}
          handleCloseModal={handleToggleAuthoritiesActionModal(false)}
        />
      )}
    </>
  )
}

InternalDocumentIncomingDocCreatePage.propTypes = {}

export default memo(
  inject(
    'commonStore',
    'internalDocumentStore',
    'fileStore',
    'authorityStore',
    'loadingAnimationStore',
    'companyStore',
    'bookStore',
    'selectPeopleStore',
    'staffStore',
    'departmentStore',
    'taskManagementStore',
    'connectedDocumentStore',
    'signedDocumentStore',
    'ScanPdfStore',
    'authenticationStore'
  )(observer(InternalDocumentIncomingDocCreatePage))
)
